if (!customElements.get('nfc-browse')) {
  customElements.define('nfc-browse', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.initialize(), {
          once: true,
          signal: this.controller.signal
        });
      } else {
        this.initialize();
      }
    }

    initialize() {
      this.searchController?.abort();
      this.searchController = new AbortController();
      const input = this.querySelector('[data-browse-search]');
      const counter = this.querySelector('[data-browse-count]');
      const empty = this.querySelector('[data-browse-empty]');
      const search = this.querySelector('[data-browse-search-wrap]');
      if (!input || !counter || !empty || !search) return;

      const normalize = (value) => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '');
      const cards = Array.from(this.querySelectorAll('[data-browse-card]'), (element) => ({
        element,
        text: normalize(element.dataset.browseText || '')
      }));
      const unit = counter.dataset.browseUnit || 'style';
      const suffix = counter.hasAttribute('data-browse-paged') ? ' on this page' : '';
      const initialCount = `${cards.length} ${unit}${cards.length === 1 ? '' : 's'}${suffix}`;
      const filterCards = () => {
        const words = normalize(input.value).trim().split(/\s+/).filter(Boolean);
        let visible = 0;
        cards.forEach(({ element, text }) => {
          const matches = words.every((word) => text.includes(word));
          element.hidden = !matches;
          if (matches) visible += 1;
        });
        empty.hidden = visible !== 0;
        if (words.length === 0) {
          counter.textContent = initialCount;
        } else {
          counter.textContent = `${visible} of ${cards.length} ${unit}${cards.length === 1 ? '' : 's'}${suffix}`;
        }
      };

      input.addEventListener('input', filterCards, { signal: this.searchController.signal });
      this.querySelector('[data-browse-clear]')?.addEventListener('click', () => {
        input.value = '';
        filterCards();
        input.focus();
      }, { signal: this.searchController.signal });
      search.hidden = false;
      filterCards();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.searchController?.abort();
    }
  });
}
